/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { appConfig } from './app/app.config';
import { App as AppComponent } from './app/app';
import { environment } from './environments/environment';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: environment.sentryRelease || undefined,
    tracesSampleRate: environment.production ? 0.1 : 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  if (environment.sentryDsn) {
    Sentry.captureException(err);
  }
});
